// src/lib/supabase/StripePlanUpgrade.ts
import { supabase } from '../supabase';

export type SessionType = 'one-time' | 'subscription' | 'recurring';

/**
 * יוצר Session ל-Stripe Checkout דרך Edge Function: "PlanUpgrade".
 * מיועד לרכישה ראשונה (כשאין customerId פעיל). ה-JWT מצורף אוטומטית.
 */
export async function createCheckoutSessionUpgrade(
  priceId: string,
  type: SessionType = 'subscription',
  customerEmail?: string,
  metadata: Record<string, string> = {}
): Promise<string> {
  // ודא שהמשתמש מחובר
  const { data: sessionWrap, error: sessionErr } = await supabase.auth.getSession();
  if (sessionErr) throw new Error(`Auth error: ${sessionErr.message}`);
  if (!sessionWrap?.session) throw new Error('Not authenticated – אנא התחבר/י מחדש');

  // קריאה לפונקציית Edge PlanUpgrade במצב "checkout"
  const { data, error } = await supabase.functions.invoke('PlanUpgrade', {
    body: { priceId, type, customerEmail, metadata }, // checkout path
  });

  if (error) {
    const status = (error as any)?.status ?? 'unknown';
    const msg =
      (error as any)?.message ||
      (typeof (error as any)?.error === 'string' && (error as any).error) ||
      'Edge Function returned a non-2xx status code';
    throw new Error(`Failed to create checkout session: ${status} - ${msg}`);
  }

  const url = (data as any)?.url as string | undefined;
  if (!url) throw new Error('No checkout URL returned from PlanUpgrade');

  return url;
}
